import type { CdaSection } from '@ctw/shared/content/document-viewer/_internal/parsers/types';
import { uniqueIdentifierForNode } from '@ctw/shared/content/document-viewer/_internal/renderers/helpers';
import { styles } from '@ctw/shared/content/document-viewer/_internal/renderers/pdf/pdf-cda-renderer';
import { StyleSheet, Text, View } from '@react-pdf/renderer';
import { PdfNodeRenderer } from './pdf-node-renderer';

interface PdfListRendererProps {
  section: CdaSection;
  list: HTMLElement;
}

const listStyles = StyleSheet.create({
  listItem: {
    fontFamily: 'Inter',
    fontWeight: 400,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
  },
  bullet: {
    fontFamily: 'Inter',
    fontWeight: 400,
    marginRight: 5,
    fontSize: 12,
    lineHeight: 1.5,
  },
});

export const PdfListRenderer = ({ section, list }: PdfListRendererProps) => {
  const listType =
    (list.getAttribute('listType') ?? list.nodeName === 'ol') ? 'ordered' : 'unordered';
  const items = Array.from(list.querySelectorAll('item,li'));

  return (
    <View style={styles.container}>
      {items.map((item, index) => (
        <View
          key={uniqueIdentifierForNode({ section, node: item, context: 'node-list-item' })}
          style={listStyles.listItem}
        >
          {listType === 'ordered' ? (
            <Text style={listStyles.bullet}>{index + 1}.</Text>
          ) : (
            <Text style={listStyles.bullet}>•</Text>
          )}
          <View style={{ flex: 1 }}>
            {Array.from(item.childNodes).map((child) => (
              <PdfNodeRenderer
                key={uniqueIdentifierForNode({
                  section,
                  node: item,
                  context: 'node-list-item-child',
                })}
                section={section}
                node={child}
              />
            ))}
          </View>
        </View>
      ))}
    </View>
  );
};
